'use strict';
import {CurationDashboardOperations} from './curation-dashboard-interface';
import {IcurationWorklistItem} from '../../../interfaces/curation-worklist-item.interface';
import {CurationUtils} from '../../../utils/curation-utils';
import {Observable} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import {AddCurationComponent} from '../../add-curation/add-curation.component';
import {IoptionElemet} from '../../../../shared/interfaces/IoptionElemet';
import {CurationActionCreatorService} from '../../../services/curation-action-creator.service';
import {CurationSettings} from '../curation-setting';
import * as _ from 'lodash';
import {catchError, flatMap} from "rxjs/operators";
import {CurationEditorHelper} from "../../curation-editor/curation-editor-helper";
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {ConvertDisciplineCodeToDisciplineName} from "@ispm/shared/constants/curation_constants";
import {ErrorMessages} from "@ispm/shared/constants/error-messages";
import {ERROR} from "@angular/compiler-cli/src/ngtsc/logging/src/console_logger";

@Injectable()
export class curationDashboardPathwaysService implements CurationDashboardOperations {

  constructor(private curationActionCreatorService: CurationActionCreatorService,
              private authService: AuthenticationService) {
  }

  adaptDataToGrid(item: IcurationWorklistItem, currentConf: any, currentUserOrgId: string) {
    CurationUtils.adaptCurationDataToGrid(item, currentConf, currentUserOrgId);
  }

  adaptDataToGridWithGrantedAction(item: IcurationWorklistItem, currentUserOrgId: string, actionGrantedForType: boolean) {
    CurationUtils.adaptDataToGridWithGrantedAction(item, currentUserOrgId, actionGrantedForType);
  }

  loadAddItemOptions(conf, newItemOptions: any[], curationTypeByFormName: Map<string, any>, loadFormFunc, context) {
  }

  getAddButtonName() {
    return 'Add new pathway';
  }

  getMockList() {
    const tempList: Array<any> = [];
    for (let i = 1; i < 100; i++) {
      tempList.push({ aberrationKey: i.toString(), status: CurationSettings.CURATION_STATUS_DRAFT, lastUpdated: i});
    }
    return Observable.of(tempList);
  }

  getCloningEnabled(): boolean {
    return true;
  }

  getCurationCreationData(itemData: { type: string; inputs: IoptionElemet[] }, formName: string) {
    const payload = { formName: formName};
    return { createComp: AddCurationComponent, payload: payload};
  }

  prepareCurationItem(model: any, curationType: string) {
    delete model['dummy'];
    model.type = curationType;
    return {
      'content': model,
      'opinion': CurationUtils.buildOpinion(this.authService.user),
    };
  }

  getCurationItemByKeys(curationToCreate: any, forCurrentOrg:boolean = false, additionalValidationSet:any, mainKbConf: any) {
    if (!!additionalValidationSet) {
      let query = {};
      if (!!_.get(additionalValidationSet, 'searchBy', undefined)
        && Array.isArray(additionalValidationSet.searchBy) && additionalValidationSet.searchBy.length > 0) {
        additionalValidationSet['searchBy'].forEach(item => {
          query[item.searchField] = _.get(curationToCreate, item.contentField, '');
        });
      }
      if (!!_.get(additionalValidationSet, 'searchWith', undefined) &&
        Array.isArray(additionalValidationSet.searchWith) && additionalValidationSet.searchWith.length > 0) {
        additionalValidationSet['searchWith'].forEach(item => {
          query[item.searchField] = _.get(item, 'value', '');
        });
      }

      const curOrg = !!mainKbConf && _.has(mainKbConf, CurationSettings.MULTIPLE_KB);

      // find curation info objects
      return this.curationActionCreatorService.searchCurationInfoWithFilter(
        {
          query: {
            ...query,
            _fieldslist: '[' + CurationSettings.CONTENT_PATHWAYBPMN_NAME + ",[" + CurationSettings.CONTENT_DISCIPLINE_CODE + ",[" + CurationSettings.CONTENT_DISEASE_CODE
          },
          type: _.get(curationToCreate, 'content.type', undefined)
        }, curOrg)
        .pipe(
          catchError(error => {
            let message = `Internal error (${ErrorMessages.GET_CURATION_ITEM_BY_KEYS}) encountered. Please try again later.`;
            return Observable.throwError(message);
          }),
          flatMap(res => {

        // analyze results
        if (Array.isArray(res) && res.length > 0) {
          let duplicatedItem;
          let foundItem = this.findByField(res, curationToCreate, CurationSettings.CONTENT_PATHWAYBPMN_NAME);
          if(!!foundItem && foundItem.length>0 && foundItem[0].status !== 'archived') {
            duplicatedItem = !!foundItem && foundItem.length > 0 ? foundItem[0] : res[0];
          }
          if(!!duplicatedItem){
            return Observable.create(function (observer) {
              let name = _.get(duplicatedItem, CurationSettings.CONTENT_PATHWAYBPMN_NAME, '');
              let discipline = _.has(duplicatedItem, CurationSettings.CONTENT_DISCIPLINE_DISPLAY) ?
                _.get(duplicatedItem, CurationSettings.CONTENT_DISCIPLINE_DISPLAY, '') :
                (_.has(duplicatedItem, CurationSettings.CONTENT_DISCIPLINE_CODE) ?
                  ConvertDisciplineCodeToDisciplineName.getDiscipline(_.get(duplicatedItem, CurationSettings.CONTENT_DISCIPLINE_CODE, '')) : '');
              let data = {
                error: { message: `with ${name} name for ${discipline} already exists`},
                name: name,
                discipline: discipline,
                status: CurationEditorHelper.MULTIPLE_CHOICES};
              observer.next(data);
              observer.complete();
            })
          }
          else
            return this.curationActionCreatorService.getCurationItemByKeysV1(curationToCreate, curOrg);
        }
        else
          return Observable.create(function (observer) {
            let data = { status: CurationEditorHelper.ERROR_ITEM_NOT_FOUND,
                         error: { 'details': 'CurationInfo not found for type' + curationToCreate.type},
                         message: 'CurationInfo not found'};

            observer.next(data);
            observer.complete();
          })
      }));
    }
    else
      return this.curationActionCreatorService.getCurationItemByKeysV1(curationToCreate, forCurrentOrg);
  }

  private findByField(res, curationToCreate: any, fieldName: string) {
    let found = res.filter(item =>
        _.has(item, fieldName) && _.has(curationToCreate, fieldName) &&
        _.get(item, fieldName, 'item') === _.get(curationToCreate, fieldName, 'curationToCreate')
    );
    return found;
  }

  createCurationItem(curationToCreate: any) {
    return this.curationActionCreatorService.createCurationItemV1(curationToCreate);
  }

  openEditorParams(response: any) {
    return {
      curationId: response.curationItem.id,
      wfId: response.curationItem.workflowRequestId,
      revisionId: response.curationData.revisionId,
      curationType: response.curationItem.type
    };
  }

  getCurationItem(curationItemId, revisionId, type) {
    return this.curationActionCreatorService.getCurationItemV1(curationItemId, revisionId, type);
  }

  public updateDataFromModel(form: any, content: any, isClonedFromAnotherOrg: boolean, grantedActionsTable?: any) {
    Object.keys(form).forEach(((key) => content[key] = form[key]));

    if (isClonedFromAnotherOrg && !!grantedActionsTable) {
      let cloneActionsTable = _.find(grantedActionsTable, el => el.action === CurationSettings.GRANTED_ACTIONS_CLONE_ACTION && el.types.some(descr => descr.curationType.toLowerCase() === content['type'].toLowerCase()));
      if (!!cloneActionsTable) {
        cloneActionsTable.types.some(typeDescr => {
          if (typeDescr.curationType.toLowerCase() == content.type.toString().toLowerCase()) {
            let cleanFields: string[] = _.get(typeDescr, CurationSettings.CURATION_CLONE_CLEAN_FIELDS, []);
            cleanFields.forEach(field => _.unset(content, field));

            return true;
          }
          return false;
        });
      }
    }
  }

}
